<template>
  <div
    class="my-button"
    :class="[
      type ? `my-button--${type}` : '',
      { 'my-button--disabled': disabled },
      { 'my-button--block': block }
    ]"
    :style="buttonStyle"
    @click="handleClick"
    role="button"
    :tabindex="disabled ? -1 : 0"
    @keydown.enter="handleClick"
    @keydown.space.prevent="handleClick"
  >
    <slot></slot>
  </div>
</template>

<script>
export default {
  name: "MyButton",
  props: {
    type: {
      type: String,
      default: "default", // 'primary', 'default'
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    width: {
      type: String,
      default: "auto",
    },
    color: {
      type: String,
      default: "",
    },
    fontSize: {
      type: String,
      default: "16px",
    },
    block: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    buttonStyle() {
      const style = {
        fontSize: this.fontSize,
      };
      
      if (this.width !== "auto") {
        style.width = this.width;
      }
      
      if (this.block) {
        style.width = "100%";
      }
      
      if (this.color) {
        style.color = this.color;
      }
      
      return style;
    },
  },
  methods: {
    handleClick(event) {
      if (!this.disabled) {
        this.$emit("click", event);
      }
    },
  },
};
</script>

<style scoped lang="scss">
.my-button {
  display: inline-block;
  height: 54px;
  padding: 0 40px;
  border-radius: 10px;
  border: none;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.2s ease;
  outline: none;
  white-space: nowrap;
  text-align: center;
  line-height: 54px;
  user-select: none;
  box-sizing: border-box;
  
  // Default type
  &--default {
    background-color: #f5f5f5;
    color: #333;
    
    &:hover:not(.my-button--disabled) {
      background-color: #e8e8e8;
    }
    
    &:active:not(.my-button--disabled) {
      background-color: #d8d8d8;
    }
  }
  
  // Primary type
  &--primary {
    background-color: var(--brandColor, #4169E1);
    color: #fff;
    
    &:hover:not(.my-button--disabled) {
      filter: brightness(1.1);
    }
    
    &:active:not(.my-button--disabled) {
      filter: brightness(0.9);
    }
  }
  
  // Disabled state
  &--disabled {
    cursor: not-allowed;
    opacity: 0.2;
    pointer-events: none;
  }
  
  // Block button
  &--block {
    display: block;
    width: 100%;
  }
  
  // Keyboard focus
  &:focus-visible {
    outline: 2px solid var(--brandColor, #4169E1);
    outline-offset: 2px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/MyButton.vue